import { call, getContext, put, takeEvery } from 'redux-saga/effects';
import { INITIALIZE } from 'ext/root/root-actions';
import keyBy from 'lodash.keyby';
import baseTheme from './base-theme';
import { patterns, insert, reject, resolve } from './actions';

function* fetchThemes() {
  const logger = yield getContext('logger');
  try {
    const api = yield getContext('api');
    const response = yield call(api.getThemes);

    yield put(resolve(keyBy(response, 'id')));
  } catch (error) {
    yield put(reject(error));
    logger.error(error);
  }
}

function* createTheme({ payload }) {
  const { name, isDefault = false, sessionInstanceTag } = payload;
  const themeModel = {
    ...baseTheme,
    isDefault,
    name,
  };

  const logger = yield getContext('logger');
  try {
    const api = yield getContext('api');
    const newTheme = yield call(api.createTheme, themeModel);
    yield call(api.publishTheme, newTheme.id);

    // Set this ephemeral value so it can be used to select the new theme in ThemeSelect
    newTheme.sessionInstanceTag = sessionInstanceTag;

    yield put(insert(newTheme));
  } catch (error) {
    logger.error(error);
    throw error;
  }
}

export default function* saga() {
  yield takeEvery(INITIALIZE, fetchThemes);
  yield takeEvery(patterns.create, createTheme);
}
